import React, { useState } from 'react';
import {
    ComponentSettingsManageFilters,
    BlocksContext,
    ComponentSettingsExternalVisualization,
    BlockType,
    ComponentSettings,
    DisplayMask,
} from '@report-content';
import useFirstDatasetMasks from './hooks/useFirstDatasetMasks';

export default function BlocksContextProvider({
    children,
    manageFiltersSettings,
    rendererBlocks,
    displayMasksList,
}: {
    children: any;
    manageFiltersSettings: ComponentSettingsManageFilters | null;
    rendererBlocks: Array<BlockType<ComponentSettings>>;
    displayMasksList: Array<DisplayMask>;
}) {
    const [filterRules, setFilterRules] = useState<any>(null);
    const [extViz, setExtViz] = useState<ComponentSettingsExternalVisualization | null>(null);
    const [manageFiltersReady, setManageFiltersReady] = useState<boolean>(false);

    const handleSetFilterRules = (rules: any) => {
        if (JSON.stringify(rules) != JSON.stringify(filterRules)) {
            setFilterRules(rules);
        }
    };

    const handleSetExtViz = (newExtViz: ComponentSettingsExternalVisualization | null) => {
        setExtViz(newExtViz);
    };
    const getFilterMask = useFirstDatasetMasks(rendererBlocks, displayMasksList);

    return (
        <BlocksContext.Provider
            value={{
                manageFiltersSettings: manageFiltersSettings,
                filters: filterRules,
                setFilters: handleSetFilterRules,
                extViz: extViz,
                manageFiltersReady: manageFiltersReady,
                setExtViz: handleSetExtViz,
                setManageFiltersReady: (status: boolean) => {
                    setManageFiltersReady(status);
                },
                getFilterMask: getFilterMask,
            }}
        >
            {children}
        </BlocksContext.Provider>
    );
}
